// extracted by mini-css-extract-plugin
export default {"root":"styles_root__EZz2L","svg":"styles_svg__GpRVg"};